import {
    GET_DIRECTION_USERS_REQ,
    GET_DIRECTION_USERS_RES
} from '../../actions'

const usersInitialState = {
    error: null,
    users: [],
    counter: 0,
    users_loaded: false
}

const tech_review_reducer = ( state = usersInitialState, action) => {
    switch( action.type ){
        case GET_DIRECTION_USERS_REQ:
            return {
                ...state,
                users_loaded: false,
            }

        case GET_DIRECTION_USERS_RES:
            return {
                ...state,
                users: action.payload,
                counter: action.counter,
                users_loaded: true,
            }

        default:
            return state
    }
}

export default tech_review_reducer;